import { Injectable } from '@angular/core';
import { ApModalReason, ApModalResult, ApModalService } from '../modals/index';
import { ApConfirmModalComponent } from './ap-confirm-modal.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApConfirmModalService {
  constructor(private apModalService: ApModalService) { }

  // Left for backwards compatibility, use openModal$ instead.
  async openModalAsync(baseId: string,
                       bodyText: string,
                       headerText: string | null = null,
                       yesButton: string | null = null,
                       noButton: string | null = null,
                       modalSize: string | null = null): Promise<boolean> {
    return this.openModal(baseId, bodyText, headerText, yesButton, noButton, modalSize);
  }

  // Left for backwards compatibility, use openModal$ instead.
  openModal(baseId: string,
            bodyText: string,
            headerText: string | null = null,
            yesButton: string | null = null,
            noButton: string | null = null,
            modalSize: string | null = null,
            hideHeader: boolean | null = null,
            hideNoButton: boolean | null = null
  ): Promise<boolean> {

    let yesButtonText = 'Yes';
    let noButtonText = 'No';
    let modalTitleText = 'Are you sure?';
    if (headerText) {
      modalTitleText = headerText;
    }
    if (yesButton) {
      yesButtonText = yesButton;
    }
    if (noButton) {
      noButtonText = noButton;
    }

    const initialState = {
      baseId,
      bodyText,
      hideHeader,
      hideNoButton,
      modalTitleText,
      noButtonText,
      yesButtonText,
    };

    const p = this.apModalService.showComponentModal(ApConfirmModalComponent, {
      panelClass: modalSize ? modalSize : 'modal-md',
      disableClose: true,
      initialState,
    }).then(modalResult => {
      if (!modalResult.isSuccess) {
        return Promise.reject(new Error(`ApConfirmModalService - modal closed, reason: ${ApModalReason[modalResult.reason]}`));
      }

      return modalResult.resultValue;
    });

    return p;
  }

  openModal$(
    baseId: string,
    bodyText: string,
    headerText: string | null = null,
    yesButton: string | null = null,
    noButton: string | null = null,
    modalSize: string | null = null,
    hideHeader: boolean | null = null,
    hideNoButton: boolean | null = null,
  ): Observable<ApModalResult<boolean>> {
    // duplicate code from openModal since that should be deleted eventually
    // and showComponentModal$ might not always be a simple wrapper around the promise
    let yesButtonText = 'Yes';
    let noButtonText = 'No';
    let modalTitleText = 'Are you sure?';
    if (headerText) {
      modalTitleText = headerText;
    }
    if (yesButton) {
      yesButtonText = yesButton;
    }
    if (noButton) {
      noButtonText = noButton;
    }

    const initialState = {
      baseId,
      bodyText,
      hideHeader,
      hideNoButton,
      modalTitleText,
      noButtonText,
      yesButtonText,
    };

    const obs = this.apModalService.showComponentModal$(ApConfirmModalComponent, {
      panelClass: modalSize ? modalSize : 'modal-md',
      disableClose: true,
      initialState,
    });

    return obs;
  }
}
